const Colors = {
  colorMaster: '#b850f9',
  colorBackground: '#303030',
  colorWhite: '#ffffff',
};

export default Colors;
